// extracted by mini-css-extract-plugin
export var resizer = "_ep-0";